import React from 'react';
import ReactDOM from 'react-dom';
import '@atresmedia/elections_modules_library/dist/scss/main.scss';
import App from './App';
import './index.scss';

const host = window.location.hostname;

window.atresmedia_elecciones = (element, path) => {
  ReactDOM.render(<App entry={path} />, element);
};

if (
  window.parent !== window ||
  window.location.hostname === 'localhost' ||
  window.location.href.indexOf('tvmodules') !== -1 ||
  window.location.href.indexOf('generador') !== -1
) {
  window.atresmedia_elecciones(
    document.getElementById('atresmedia-elecciones-root'),
    ''
  );
}

// Resize amp iframe helper
let previousSize = 0;
if (window.location.href.indexOf('#amp=1') !== -1 && window.parent !== window) {
  setInterval(() => {
    if (
      document.body.scrollHeight > 100 &&
      document.body.scrollHeight !== previousSize
    ) {
      previousSize = document.body.scrollHeight;
      window.parent.postMessage(
        {
          sentinel: 'amp',
          type: 'embed-size',
          height: document.body.scrollHeight
        },
        '*'
      );
    }
  }, 1000);
}

window.__debug__ = true;
